import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Team } from '../team.model';
import { UserService } from '../../users/user.service';
import { TeamService } from '../team.service';

@Component({
  selector: 'app-team-add',
  templateUrl: './team-add.component.html',
  styleUrls: ['./team-add.component.css']
})
export class TeamAddComponent implements OnInit {

  public teamForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<TeamAddComponent>,
    @Inject(MAT_DIALOG_DATA) public team: Team,
    private fb: FormBuilder,
    private userService: UserService,
    private teamService: TeamService) {
    this.createForm();
  }

  ngOnInit() {
  }

  createForm() {
    this.teamForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern(/^[a-zA-Z ()\s]*$/)]]
    });
    }

  sanitizeInput(event: any) {
    event.target.value = event.target.value.replace(/[^a-zA-Z ()\s]/g, '');
  }

  onSubmit() {
    if (!this.teamForm.valid)
      return;

    this.team = this.prepareSaveTeam();
    this.teamService.addTeam(this.team)
      .then(result => this.dialogRef.close(result))
      .catch(error => console.log(error));
  }

  getLoggedInUser() {
    var loggedInUser = this.userService.currentUser;
    return loggedInUser;
  }

  prepareSaveTeam(): Team {
    const formModel = this.teamForm.value;
    var saveTeam = new Team();
    saveTeam.id = null;
    saveTeam.name = formModel.name as string;
    saveTeam.partnerCount = null;
    saveTeam.loggedInUserEmail = this.getLoggedInUser().email;
    return saveTeam;
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/teams/team-add/team-add.component.ts